import { useState, useRef } from 'react';
import { Copy01Icon, Tick01Icon, TickDouble01Icon } from 'hugeicons-react';
import { copyRichText } from '../../../helpers/chatHelper';
import { HoverToolTip } from '../Items/HoverToolTip';

interface CopyButtonProps {
  item: {
    content: string;
    [key: string]: any;
  };
  showHoverText?: boolean;
  useRichCopy?: boolean;
  className?: string;
  size?: number;
}

export const CopyButton = ({ item, showHoverText = true, useRichCopy = true, className = "action-button", size = 16 }: CopyButtonProps) => {
    const [isHolding, setIsHolding] = useState(false);
    const holdTimeout = useRef<NodeJS.Timeout | null>(null);
    const HOLD_DURATION = 500; // milliseconds
    const [isCopied, setIsCopied] = useState(false);
    const [isRichCopied, setIsRichCopied] = useState(false);
  
    const resetCopyState = () => {
      setTimeout(() => {
        setIsCopied(false);
        setIsRichCopied(false);
      }, 2000); // Show copy confirmation for 2 seconds
    };
  
    const handleMouseDown = () => {
      holdTimeout.current = setTimeout(() => {
        setIsHolding(true);
        if(useRichCopy) {
          copyRichText(item.content);
          setIsRichCopied(true);
        } else {
          navigator.clipboard.writeText(item.content);
          setIsCopied(true);
        }
        resetCopyState();
      }, HOLD_DURATION);
    };
  
    const handleMouseUp = () => {
      if (holdTimeout.current) {
        clearTimeout(holdTimeout.current);
      }
      if (!isHolding) {
        navigator.clipboard.writeText(item.content);
        setIsCopied(true);
        resetCopyState();
      }
      setIsHolding(false);
    };
  
    const handleMouseLeave = () => {
      if (holdTimeout.current) {
        clearTimeout(holdTimeout.current);
      }
      setIsHolding(false);
    };
  
    return (
      <button 
        className={className}
        aria-label="Copy message"
        title="Copy message"
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        {isRichCopied ? (
          <TickDouble01Icon size={size} />
        ) : (
          isCopied ? (
            <Tick01Icon size={size} />
          ) : (
            <Copy01Icon size={size} />
          )
        )}
        {showHoverText && (
          <HoverToolTip
            text={isRichCopied ? "Rich Copied" : (
              useRichCopy ? "Hold to Rich Copy" : isCopied ? "Copied" : "Copy"
            )}
            position="bottom"
          />
        )}
      </button>
    );
  };
  